import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    HStack,
    Link,
    Button,
    Image,
    ButtonProps,
    Heading,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { FindAMentor } from "../views/FindAMentor";

export function ClickMe() {
    return (<FindAMentor />);
}

export default function SimpleCard() {
    return (
        <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}>
            <HStack borderWidth="1px"
        borderRadius="lg"
        w={{ sm: '100%', md: '1000px' }}
        height={{ sm: '1000px', md: '20rem' }}
        direction={{ base: 'column', md: 'row' }}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        padding={4}>
                <Box w='400px' justifyContent="center"
          alignItems="center" bg={useColorModeValue('red', 'orange.200')} p={8}>
                    <Image boxSize='400px' objectFit='cover' src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fassets.entrepreneur.com%2Fcontent%2F3x2%2F2000%2F20190715192128-GettyImages-1074061764.jpeg&f=1&nofb=1&ipt=2b6c0ad6ecf9539c58d6fa0c5a4fec0a2ce70b9620e219570351456e70f5528f&ipo=images' />
                </Box>
                <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                    <Stack align={'center'}>
                        <Heading fontSize={'4xl'}>Sign in to your account</Heading>
                        <Text fontSize={'lg'} color={'gray.600'}>
                            to enjoy all of our cool <Link color={'blue.400'}>features</Link> ✌️
                        </Text>
                    </Stack>
                    <Box
                        rounded={'lg'}
                        bg={useColorModeValue('white', 'gray.700')}
                        boxShadow={'lg'}
                        p={8}>
                        <Stack spacing={4}>
                            <FormControl id="email">
                                <FormLabel>Email address</FormLabel>
                                <Input type="email" />
                            </FormControl>
                            <FormControl id="password">
                                <FormLabel>Password</FormLabel>
                                <Input type="password" />
                            </FormControl>
                            <Stack spacing={10}>
                                <Stack
                                    direction={{ base: 'column', sm: 'row' }}
                                    align={'start'}
                                    justify={'space-between'}>
                                    <Checkbox>Remember me</Checkbox>
                                    <Link color={'blue.400'}>Forgot password?</Link>
                                </Stack>
                                <Button
                                    bg={'blue.400'}
                                    color={'white'}
                                    _hover={{
                                        bg: 'blue.500',
                                    }}
                                    //Sign in
                                    onClick={() => ClickMe()}>
                                    Sign in
                                </Button>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </HStack>

        </Flex>
    );
}

export { }